import React, { useState, useRef } from "react";
import "./CopyField.css";

// Read-only field + copy button. Used for the referral link.
export default function CopyField({ value, label }) {
  const [copied, setCopied] = useState(false);
  const timer = useRef(null);

  const doCopy = async () => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(value);
      } else {
        // fallback for in-app wallet browsers without clipboard API
        const ta = document.createElement("textarea");
        ta.value = value;
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.focus();
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="copy-field">
      {label && <div className="field-label">{label}</div>}
      <div className="copy-row">
        <input className="copy-input" value={value} readOnly onFocus={(e) => e.target.select()} />
        <button className={`copy-btn ${copied ? "done" : ""}`} onClick={doCopy}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
    </div>
  );
}
